import {
  CardComponent,
  AtlasCaption,
  AtlasBodySubtitle,
  AtlasColor
} from '@justomx/atlas-components'
import { Icon } from '@justomx/atlas-icons'
import { StackAtom } from 'components/atoms/Stack.atom'
import { OtpInputMolecule } from 'components/molecule/OtpInput.molecule'

interface ApprovalScreenProps {
  onConfirmOTPCode: (otpCode: string) => void
}

export const ApprovalScreenOrganism = (props: ApprovalScreenProps) => {
  const { onConfirmOTPCode } = props

  return (
    <StackAtom $direction="column" $gap={24}>
      <CardComponent
        $variant="highlight"
        style={{ background: '#282828', padding: '14px 18px' }}
      >
        <StackAtom $gap={10} $align="center">
          <Icon name="ic_information" size={24} color={AtlasColor.TextStroke} />

          <AtlasCaption>
            Esta acción requiere un código de autorización, solicítalo a tu
            supervisor.
          </AtlasCaption>
        </StackAtom>
      </CardComponent>

      <AtlasBodySubtitle>Escribe el código:</AtlasBodySubtitle>

      <OtpInputMolecule onComplete={onConfirmOTPCode} />
    </StackAtom>
  )
}
